module.exports = __webpack_public_path__ + "img/Group117.56e472ea.png";